import React, { useMemo } from "react";

import { Trans, useTranslation } from "react-i18next";

import { Text, TextProps } from "@mantine/core";

import {
  type SurveyEngineText,
  TranslationKey,
} from "@neuromotion-inc/mightier-survey-engine";

import type { SurveyEngineIface } from "src/services/surveyHooks/useSurveyEngine";

interface _SurveyRichTextProps extends TextProps {
  // TODO: eventually once SurveyConfig object uses type SurveyEngineText
  // for everything, we can remove the TranslationKey type
  text: SurveyEngineText | TranslationKey;
  surveyEngine: SurveyEngineIface;
}

type SurveyRichTextProps = Omit<_SurveyRichTextProps, "children">;

const isTextObjNotJustKey = (
  text: SurveyEngineText | TranslationKey,
): text is SurveyEngineText => {
  return typeof text === "object";
};

export const SurveyRichText = React.memo<SurveyRichTextProps>(
  function SurveyRichText(props) {
    const { text, surveyEngine, ...restOfProps } = props;

    const i18nKey = useMemo(() => {
      return isTextObjNotJustKey(text) ? text.translation_key : text;
    }, [text]);

    const { t } = useTranslation("mightier_survey_lib");

    return (
      <Text {...restOfProps}>
        <Trans
          t={t}
          i18nKey={i18nKey}
          values={surveyEngine.translationContext}
          components={{
            // NOTE: `span` is same as `component='span'` and makes it so there's no line break
            b: <Text fw="bold" span {...restOfProps} />,
            i: <Text fs="italic" span {...restOfProps} />,
            u: <Text td="underline" span {...restOfProps} />,
          }}
        />
      </Text>
    );
  },
);
